export default __webpack_public_path__ + "static/media/team-performance.8ab9219a.svg";